/* Utilitaires date autonomes de l'export (alignés sur ceux de l'application). */
export { MONTHS_FULL } from '../constants';
export const DOW = ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'];

export function pad(n) {
  return String(n).padStart(2, '0');
}
export function isoOf(y, m, d) {
  return `${y}-${pad(m + 1)}-${pad(d)}`;
}

// Dimanche de Pâques (algorithme de Meeus/Jones/Butcher).
function paques(y) {
  const a = y % 19,
    b = Math.floor(y / 100),
    c = y % 100,
    d = Math.floor(b / 4),
    e = b % 4,
    f = Math.floor((b + 8) / 25),
    g = Math.floor((b - f + 1) / 3),
    h = (19 * a + b - d - g + 15) % 30,
    i = Math.floor(c / 4),
    k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7,
    mm = Math.floor((a + 11 * h + 22 * l) / 451),
    month = Math.floor((h + l - 7 * mm + 114) / 31),
    day = ((h + l - 7 * mm + 114) % 31) + 1;
  return new Date(y, month - 1, day);
}

// Jours fériés français de l'année (dates ISO).
export function holidaysSet(year) {
  const p = paques(year);
  const add = (dt, n) => {
    const x = new Date(dt);
    x.setDate(x.getDate() + n);
    return isoOf(x.getFullYear(), x.getMonth(), x.getDate());
  };
  return new Set([
    `${year}-01-01`,
    add(p, 1),
    `${year}-05-01`,
    `${year}-05-08`,
    add(p, 39),
    `${year}-07-14`,
    `${year}-08-15`,
    `${year}-11-01`,
    `${year}-11-11`,
    `${year}-12-25`,
  ]);
}

// Numéro de semaine ISO 8601
export function isoWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const day = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}

export const isWeekend = (dt) => dt.getDay() === 0 || dt.getDay() === 6;
